export default function formatTime(time) {
  if (!time) return ''
  return `${time.slice(0,4)}-${time.slice(4,6)}-${time.slice(6,8)}`
}